import {
    getItemLaunchType,
    getItemTypeFromMetadata,
    compoundTypes,
} from '../../store/draft/types.js';
import { toDurationFromMetadata } from '../../helpers/converters.js';
import { translate } from '../../helpers/translate.js';

export const getItemChanges = (item, elearning) => {
    return {
        launchId: elearning.targetId,
        elearningItemName: elearning.title,
        launchType: getItemLaunchType(elearning),
        playerType: elearning.playerType,
        image: item.type.indexOf(compoundTypes.COMPOUND) === -1 && !!elearning.thumbnail ? elearning.thumbnail : item.image,
        name: hasNewItemName(item.name) ? elearning.title : item.name,
        type: item.type === '' ? getItemTypeFromMetadata(elearning.metadata) || '' : item.type,
        duration: toDurationFromMetadata(elearning.metadata) || item.duration,
    };
};

const hasNewItemName = (name) => [translate('newBlockItem'), translate('newBlock')].indexOf(name) > -1;